import { render, staticRenderFns } from "./AddNewInvitationsButtons.vue?vue&type=template&id=44844e96&scoped=true&"
import script from "./AddNewInvitationsButtons.vue?vue&type=script&lang=js&"
export * from "./AddNewInvitationsButtons.vue?vue&type=script&lang=js&"
import style0 from "./AddNewInvitationsButtons.vue?vue&type=style&index=0&id=44844e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44844e96",
  null
  
)

export default component.exports